export default {
  getListOrganizations: (state) => state.listOrganizations || [],
}